<template>
  <div class="hkl-pencil-textarea">
    <PencilEdit
      ref="modal"
      :canEdit="canEdit"
      @open="onOpen"
      @close="onClose"
    >
      <HKLTextarea
        v-model="inputData"
        v-focus
      />
      <pre
        slot="display-show"
        class="field__display"
        :class="displayTextClass"
        @dblclick="() => onDoubleClick()"
      >{{ displayText }}</pre>
    </PencilEdit>
  </div>
</template>

<script>
import { ref, unref, computed } from 'vue-demi'
import PencilEdit from '@/controls/PencilEdit/index.vue'
import { useRefModal } from '@/controls/Modal/modal.hook'
import i18n from '@/utils/i18n'
import HKLTextarea from './HKLTextarea.vue'

/**
 * @type {import('vue').Component}
 */
export default {
  components: {
    PencilEdit,
    HKLTextarea,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
    defaultHint: {
      type: String,
      default: () => i18n.t('project.docs.fillDescHint'),
    },
    defaultValue: {
      type: String,
      default: '',
    },
  },
  setup (props, { emit }) {
    const { modal, open, close } = useRefModal()
    const inputData = ref('')
    const displayText = computed(() => {
      return props.value || props.defaultHint
    })
    const displayTextClass = computed(() => {
      const hasNewline = /\n/.test(props.value)
      return hasNewline ? 'newline' : ''
    })
    const onDoubleClick = () => {
      if (props.canEdit) open()
      return false
    }
    return {
      onDoubleClick,
      displayTextClass,
      displayText,
      inputData,
      modal,
      open,
      close,
      onOpen () {
        inputData.value = props.value || props.defaultValue
        emit(open.name)
      },
      onClose () {
        emit(close.name, unref(inputData))
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.hkl-pencil-textarea ::v-deep {
  font-size: 14px;
  font-weight: bold;
  .field__display {
    &.newline {
      display: block;
    }
  }
  .field__edit {
    width: 100%;
  }
}
</style>
